module.exports = __webpack_public_path__ + "static/img/products discription_rooftop2.153fd7cc.jpg";